import { homeConstants } from "../_constants";

export const getRealTimeRewardCodeRequest = () => {
    return {
        type: homeConstants.HOME_GET_REALTIME_REWARD_CODE_REQUEST,
    };
};

export const getRealTimeRewardCodeComplete = (payload) => {
    return {
        type: homeConstants.HOME_GET_REALTIME_REWARD_CODE_COMPLETE,
        payload,
    };
};

export const getRealTimeRewardReasonListRequest = () => {
    return {
        type: homeConstants.HOME_GET_REALTIME_REWARD_REASON_LIST_REQUEST,
    };
};

export const getRealTimeRewardReasonListComplete = (payload) => {
    return {
        type: homeConstants.HOME_GET_REALTIME_REWARD_REASON_LIST_COMPLETE,
        payload,
    };
};

export const getParticipantListRequest = () => {
    return {
        type: homeConstants.HOME_GET_PARTICIPANT_LIST_REQUEST,
    };
};

export const getParticipantListComplete = (payload) => {
    return {
        type: homeConstants.HOME_GET_PARTICIPANT_LIST_COMPLETE,
        payload,
    };
};

export const smsRealTimeRewardCodeRequest = (payload) => {
    return {
        type: homeConstants.HOME_SMS_REALTIME_REWARD_CODE_REQUEST,
        payload,
    };
};

export const smsRealTimeRewardCodeComplete = (payload) => {
    return {
        type: homeConstants.HOME_SMS_REALTIME_REWARD_CODE_COMPLETE,
        payload,
    };
};

export const homeCampaignListRequest = () => {
    return {
        type: homeConstants.HOME_CAMPAIGN_LIST_REQUEST,
    };
};

export const homeCampaignListComplete = (payload) => {
    return {
        type: homeConstants.HOME_CAMPAIGN_LIST_COMPLETE,
        payload,
    };
};

export const homeGetRealTimeRewardCampaignRequest = (payload) => {
    return {
        type: homeConstants.HOME_GET_REAL_TIME_REWARD_CAMPAIGN_REQUEST,
        payload,
    };
};

export const homeGetRealTimeRewardCampaignComplete = (payload) => {
    return {
        type: homeConstants.HOME_GET_REAL_TIME_REWARD_CAMPAIGN_COMPLETE,
        payload,
    };
};

export const clearHome = () => {
    return {
        type: homeConstants.HOME_CLEAR,
    };
};

export const homeChatbotReplyQuestionRequest = (payload) => {
    return {
        type: homeConstants.HOME_CHATBOT_REPLY_QUESTION_REQUEST,
        payload,
    };
};

export const getParticipantJobRoleRequest = (payload) => {
    return {
        type: homeConstants.GET_PARTICIPANT_JOB_ROLES_REQUEST,
        payload,
    };
};

export const homeChatbotReplyQuestionComplete = (payload) => {
    return {
        type: homeConstants.HOME_CHATBOT_REPLY_QUESTION_COMPLETE,
        payload,
    };
};

export const getParticipantJobRoleComplete = (payload) => {
    return {
        type: homeConstants.GET_PARTICIPANT_JOB_ROLES_COMPLETE,
        payload,
    };
};

export const homeGetChatbotFaqQuestionsRequest = (payload) => {
    return {
        type: homeConstants.HOME_GET_CHATBOT_FAQ_QUESTIONS_REQUEST,
        payload,
    };
};

export const getDealerParticipantListRequest = (payload) => {
    return {
        type: homeConstants.GET_DEALER_PARTICIPANT_LIST_REQUEST,
        payload,
    };
};

export const homeGetChatbotFaqQuestionsComplete = (payload) => {
    return {
        type: homeConstants.HOME_GET_CHATBOT_FAQ_QUESTIONS_COMPLETE,
        payload,
    };
};
export const getDealerParticipantListComplete = (payload) => {
    return {
        type: homeConstants.GET_DEALER_PARTICIPANT_LIST_COMPLETE,
        payload,
    };
};

export const registerDealerParticipantRequest = (payload) => {
    return {
        type: homeConstants.REGISTER_DEALER_PARTICIPANT_REQUEST,
        payload,
    };
};

export const registerDealerParticipantComplete = (payload) => {
    return {
        type: homeConstants.REGISTER_DEALER_PARTICIPANT_COMPLETE,
        payload,
    };
};

export const removeDealerParticipantRequest = (payload) => {
    return {
        type: homeConstants.REMOVE_DEALER_PARTICIPANT_REQUEST,
        payload,
    };
};

export const removeDealerParticipantComplete = (payload) => {
    return {
        type: homeConstants.REMOVE_DEALER_PARTICIPANT_COMPLETE,
        payload,
    };
};

export const updateDealerParticipantStatusRequest = (payload) => {
    return {
        type: homeConstants.UPDATE_DEALER_PARTICIPANT_STATUS_REQUEST,
        payload,
    };
};

export const updateDealerParticipantStatusComplete = (payload) => {
    return {
        type: homeConstants.UPDATE_DEALER_PARTICIPANT_STATUS_COMPLETE,
        payload,
    };
};

export const requestActivateAccountRequest = (payload) => {
    return {
        type: homeConstants.SEND_ACTIVATE_ACCOUNT_REQUEST,
        payload,
    };
};

export const requestActivateAccountComplete = (payload) => {
    return {
        type: homeConstants.SEND_ACTIVATE_ACCOUNT_COMPLETE,
        payload,
    };
};

export const homeUserLoginStatusRequest = (payload) => {
    return {
        type: homeConstants.HOME_USER_LOGIN_STATUS_REQUEST,
        payload,
    };
};

export const homeUserLoginStatusComplete = (payload) => {
    return {
        type: homeConstants.HOME_USER_LOGIN_STATUS_COMPLETE,
        payload,
    };
};

export const homeGetTeamGamePlayDetailsRequest = (payload) => {
    return {
        type: homeConstants.HOME_GET_TEAM_GAME_PLAY_DETAILS_REQUEST,
        payload,
    };
};

export const homeGetTeamGamePlayDetailsComplete = (payload) => {
    return {
        type: homeConstants.HOME_GET_TEAM_GAME_PLAY_DETAILS_COMPLETE,
        payload,
    };
};

export const homeSendGamePlayCodeRequest = (payload) => {
    return {
        type: homeConstants.HOME_GET_TEAM_SEND_GAME_PLAY_CODE_REQUEST,
        payload,
    };
};

export const homeSendGamePlayCodeComplete = (payload) => {
    return {
        type: homeConstants.HOME_GET_TEAM_SEND_GAME_PLAY_CODE_COMPLETE,
        payload,
    };
};

export const homeResetGamePlayCodeRequest = (payload) => {
    return {
        type: homeConstants.HOME_GET_TEAM_RESET_GAME_PLAY_CODE_REQUEST,
        payload,
    };
};

export const homeResetGamePlayCodeComplete = (payload) => {
    return {
        type: homeConstants.HOME_GET_TEAM_RESET_GAME_PLAY_CODE_COMPLETE,
        payload,
    };
};

export const homeGetNotificationRequest = (payload) => {
    return {
        type: homeConstants.HOME_GET_NOTIFICATIONS_REQUEST,
        payload,
    };
};

export const homeGetNotificationComplete = (payload) => {
    return {
        type: homeConstants.HOME_GET_NOTIFICATIONS_COMPLETE,
        payload,
    };
};

export const homeDeleteNotificationRequest = (payload) => {
    return {
        type: homeConstants.HOME_DELETE_NOTIFICATIONS_REQUEST,
        payload,
    };
};

export const homeDeleteNotificationComplete = (payload) => {
    return {
        type: homeConstants.HOME_DELETE_NOTIFICATIONS_COMPLETE,
        payload,
    };
};

export const homeGetNotificationCountRequest = (payload) => {
    return {
        type: homeConstants.HOME_GET_NOTIFICATION_COUNT_REQUEST,
        payload,
    };
};

export const homeGetNotificationCountComplete = (payload) => {
    return {
        type: homeConstants.HOME_GET_NOTIFICATION_COUNT_COMPLETE,
        payload,
    };
};
